import { createClient, type SupabaseClient } from '@supabase/supabase-js';
import { env } from './env.js';
import type { Database } from '../types/database.js';

/** localStorage key holding the session. Kept in sync with `e2e/fixtures/session.ts`. */
export const AUTH_STORAGE_KEY = 'budget-auth';

/**
 * The one Supabase client for the app.
 *
 * It only ever holds the anon key. Every table is default-deny under RLS, so
 * this key alone grants nothing — the user's session does. The service role
 * key exists only inside Edge Functions and must never reach this bundle.
 */
export const supabase: SupabaseClient<Database> = createClient<Database>(
  env.supabaseUrl,
  env.supabaseAnonKey,
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
      flowType: 'pkce',
      // Pinned rather than derived from the project URL, so the e2e suite can
      // seed a session deterministically and local/staging do not collide.
      storageKey: AUTH_STORAGE_KEY,
    },
  },
);

export type { Database };
